import { Sunrise, Sun, CloudSun, Sunset, Moon, MoonStar } from "lucide-react";
import { PRAYER_LABELS, currentPrayer } from "@/lib/format";
import { SectionTitle } from "./SectionTitle";

const ICONS = { subuh: Sunrise, terbit: Sun, dzuhur: Sun, ashar: CloudSun, maghrib: Sunset, isya: MoonStar };
const ORDER = ["subuh", "terbit", "dzuhur", "ashar", "maghrib", "isya"];

export const PrayerSection = ({ prayer }) => {
  const active = currentPrayer(prayer?.times);
  return (
    <section id="jadwal" className="scroll-mt-24" data-testid="prayer-section">
      <SectionTitle eyebrow="Hari Ini" title="Waktu Sholat Hari Ini" desc={`${prayer?.hari || ""} ${prayer?.tanggal || ""} · ${prayer?.lokasi || "Kab. Ciamis"}. Waktu yang sedang berlangsung ditandai dengan warna hijau.`} />
      <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {ORDER.map((k, i) => {
          const Icon = ICONS[k] || Moon;
          const isActive = active === k;
          return (
            <div
              key={k}
              className={`card-hover rounded-3xl p-5 border rise ${isActive ? "emerald-bg text-white border-transparent shadow-xl pulse-gold" : "bg-white border-emerald-900/10 text-emerald-950"}`}
              style={{ animationDelay: `${i * 0.06}s` }}
              data-testid={`prayer-card-${k}`}
            >
              <div className={`h-10 w-10 rounded-2xl flex items-center justify-center ${isActive ? "bg-[#d4af37] text-emerald-950" : "bg-emerald-50 text-emerald-800"}`}>
                <Icon size={18} />
              </div>
              <p className={`mt-5 text-xs font-semibold uppercase tracking-widest ${isActive ? "text-emerald-200" : "text-emerald-700"}`}>{PRAYER_LABELS[k]}</p>
              <p className="mt-1 text-2xl font-extrabold tracking-tight" data-testid={`prayer-time-${k}`}>{prayer?.times?.[k] || "--:--"}</p>
              {isActive && <p className="mt-2 text-[11px] text-[#d4af37] font-semibold">Waktu saat ini</p>}
            </div>
          );
        })}
      </div>
      {prayer?.times?.imsak && (
        <p className="mt-5 text-sm text-slate-500">Imsak {prayer.times.imsak} · Dhuha {prayer.times.dhuha}</p>
      )}
    </section>
  );
};
